/**
 * @generated SignedSource<<db4c5c6a8151630d7b37391460c640a0>>
 * @relayHash f557abda1cabc17ba836a51cc4ae26b4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID e050710552e2b21cda2300c81f90dab7cd573d24d30a1ec448daa70b36b5c0b6

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type JiraDiscardUserIssueSearchConfigInput = {
  viewId: string;
};
export type SaveResetViewSettingsButtonUIDiscardSettingsMutation$variables = {
  input: JiraDiscardUserIssueSearchConfigInput;
};
export type SaveResetViewSettingsButtonUIDiscardSettingsMutation$data = {
  readonly jira_discardUserIssueSearchConfig: {
    readonly errors: ReadonlyArray<{
      readonly extensions: {
        readonly errorType: string | null | undefined;
        readonly statusCode: number | null | undefined;
      } | null | undefined;
      readonly message: string | null | undefined;
    }> | null | undefined;
    readonly success: boolean;
  } | null | undefined;
};
export type SaveResetViewSettingsButtonUIDiscardSettingsMutation = {
  response: SaveResetViewSettingsButtonUIDiscardSettingsMutation$data;
  variables: SaveResetViewSettingsButtonUIDiscardSettingsMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "success"
},
v3 = {
  "kind": "ScalarField",
  "name": "message"
},
v4 = {
  "kind": "ScalarField",
  "name": "errorType"
},
v5 = {
  "kind": "ScalarField",
  "name": "statusCode"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "SaveResetViewSettingsButtonUIDiscardSettingsMutation",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "JiraDiscardUserIssueSearchConfigPayload",
        "kind": "LinkedField",
        "name": "jira_discardUserIssueSearchConfig",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "concreteType": "MutationError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              {
                "kind": "LinkedField",
                "name": "extensions",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v5/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SaveResetViewSettingsButtonUIDiscardSettingsMutation",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "JiraDiscardUserIssueSearchConfigPayload",
        "kind": "LinkedField",
        "name": "jira_discardUserIssueSearchConfig",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "concreteType": "MutationError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              {
                "kind": "LinkedField",
                "name": "extensions",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "__typename"
                  },
                  (v4/*: any*/),
                  (v5/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "id"
                      }
                    ],
                    "type": "BulkMutationErrorExtension"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "e050710552e2b21cda2300c81f90dab7cd573d24d30a1ec448daa70b36b5c0b6",
    "metadata": {},
    "name": "SaveResetViewSettingsButtonUIDiscardSettingsMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "f580f77a915c03ac04e06dc773ca51fa";

export default node;
